function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M93,49.9c-0.7-0.4-2.2-0.6-4.7-0.6h-4.2v11.5H89c1.9,0,3.1-0.1,3.6-0.3c0.8-0.2,1.4-0.8,1.9-1.7 c0.5-0.9,0.8-2.1,0.8-3.6c0-1.3-0.2-2.4-0.6-3.3C94.3,50.9,93.7,50.3,93,49.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M91.3,42c0.9-0.2,1.6-0.7,2.1-1.5c0.5-0.8,0.8-1.9,0.8-3.3c0-1.3-0.2-2.4-0.7-3.2c-0.4-0.8-1.1-1.3-1.9-1.5 c-0.5-0.1-2-0.1-4.4-0.1h-3v9.9h3.4C89.6,42.2,90.9,42.1,91.3,42z"
}), React.createElement("path", {
  className: "st0",
  d: "M100.4,16.7H20c-7.8,0-14.2,6.4-14.2,14.2v30.2c0,7.8,6.4,14.2,14.2,14.2h80.4c7.8,0,14.2-6.4,14.2-14.2V30.9 C114.7,23.1,108.4,16.7,100.4,16.7z M38.3,67.9l-2.3-9.7H25.8l-2.2,9.7h-5.6l10.1-42.7h5.6L44,67.9H38.3z M70,67.9h-5.6l-5.1-32 l-5.1,32h-5.7l-6.2-42.7h5.3l3.9,29.4l4.7-29.4h6.2L66.9,55l4-29.9h5.3L70,67.9z M99.8,61.1c-0.6,1.8-1.3,3.3-2.2,4.4 c-1,1.1-2.1,1.8-3.5,2c-0.9,0.1-3,0.3-6.3,0.3H79V25.2h10.3c2,0,3.5,0.1,4.6,0.4c1,0.3,1.9,0.9,2.7,1.7c0.8,0.9,1.5,2.1,2,3.5 s0.8,3.1,0.8,5c0,2-0.3,3.8-1,5.5c-0.6,1.7-1.5,2.9-2.6,3.8c1.6,0.8,2.8,2.1,3.6,3.9s1.3,4,1.3,6.5 C100.6,57.5,100.3,59.3,99.8,61.1z"
}), React.createElement("polygon", {
  className: "st0",
  points: "27.4,51 34.4,51 30.8,35.2  "
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M147.5,74.6l22.6-58.8h8.4l24.1,58.8h-8.9l-6.9-17.8h-24.6l-6.5,17.8H147.5z M164.5,50.5h19.9l-6.1-16.3 c-1.9-4.9-3.3-9-4.2-12.2c-0.7,3.8-1.8,7.5-3.2,11.2L164.5,50.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M216,74.6l-15.6-58.8h8l8.9,38.6c1,4,1.8,8.1,2.5,12c1.5-6.3,2.4-9.9,2.6-10.9l11.2-39.7h9.4l8.4,29.8 c2.1,7.4,3.6,14.3,4.6,20.8c0.7-3.7,1.7-8,2.9-12.8l9.2-37.8h7.8l-16.1,58.8h-7.5l-12.4-44.8c-1-3.7-1.7-6-1.8-6.9 c-0.6,2.7-1.2,5-1.7,6.9l-12.5,44.8C223.9,74.6,216,74.6,216,74.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M282.9,74.6V15.8H305c4.5,0,8.1,0.6,10.8,1.8c2.7,1.2,4.8,3,6.4,5.5c1.5,2.5,2.3,5.1,2.3,7.8 c0,2.5-0.7,4.9-2,7.1c-1.4,2.2-3.4,4-6.2,5.4c3.6,1,6.3,2.8,8.2,5.3c1.9,2.5,2.9,5.5,2.9,8.9c0,2.8-0.6,5.3-1.7,7.7 c-1.2,2.4-2.6,4.2-4.3,5.5s-3.9,2.3-6.4,2.9c-2.6,0.7-5.7,1-9.5,1L282.9,74.6L282.9,74.6z M290.7,40.5h12.7c3.5,0,5.9-0.2,7.4-0.7 c2-0.6,3.5-1.6,4.5-2.9c1-1.4,1.5-3.1,1.5-5.1s-0.5-3.7-1.4-5.2s-2.3-2.5-4-3s-4.7-0.8-8.9-0.8h-11.8V40.5z M290.7,67.7h14.6 c2.5,0,4.3-0.1,5.3-0.3c1.8-0.3,3.3-0.9,4.5-1.6s2.2-1.8,3-3.3c0.8-1.4,1.2-3.1,1.2-5c0-2.2-0.6-4.1-1.7-5.7 c-1.1-1.6-2.7-2.8-4.7-3.4c-2-0.7-4.9-1-8.6-1h-13.6V67.7z"
}));

var SvgAwbIcon = function SvgAwbIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342.9 93",
    style: {
      enableBackground: "new 0 0 342.9 93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwbIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awb-icon.c0a515ce.svg";
export { ForwardRef as ReactComponent };